import ShareIcon from "@/DesignSystem/Atoms/Icons/Types/ShareNetwork/share-network-fill.svg";
import PortalIcon from "./PortalIcon.svg";

/** The props for portal status icon or button */
interface PortalStatusProps {
    /** The status colour if provided; otherwise grey. */
    background?: "blue" | "lightBlue" | "orange" | "lightOrange",

    /** The status badge if provided. */
    badge?: "error" | "ok" | "pending" | "refused" | "revoked" | "locked",

    /** The size if provided; otherwise normal. */
    buttonSize?: "small" | "large",

    /** The icon  */
    icon?: "portal" | "share"
}

function getHTMLProps<T>(props: PortalStatusProps & React.HTMLAttributes<T>, isButton: boolean): React.HTMLAttributes<T> {
    let {
        background,
        badge,
        buttonSize,
        icon,
        ...htmlProps
    } = props;

    const hasClickHandler = !!(props.onClick || props.onDoubleClick);

    const portalButtonClass = htmlProps.className
        ? htmlProps.className.split(" ")
        : [];

    if (isButton) {
        portalButtonClass.push("button");

        if (!hasClickHandler) {
            console.debug("PortalStatusButton was created without click event handling. Suggest using PortalStatusIcon.");
        }
    }
    else if (hasClickHandler) {
        console.debug("PortalStatusIcon was created with click event handling. Suggest using PortalStatusButton.");
    }

    portalButtonClass.push("portal-status");

    if (background)
        portalButtonClass.push(`${background}face`);

    if (badge)
        portalButtonClass.push(badge);

    if (buttonSize)
        portalButtonClass.push(buttonSize);

    if (icon)
        portalButtonClass.push(icon);

    htmlProps.className = portalButtonClass.distinct().join(" ");

    return htmlProps;
}

/**
 * A button that will display the current portal status of an item.
 */
class PortalStatusButton extends React.Component<PortalStatusProps & React.HTMLProps<HTMLButtonElement>, never> {
    public render(): JSX.Element {
        return (
            <button {...getHTMLProps<HTMLButtonElement>(this.props, true)}>
                {cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 && this.props.icon === "share"
                    ? <ShareIcon />
                    : <PortalIcon />
                }
            </button>
        );
    }
}

/**
 * A badge that will display the current portal status of an item.
 */
class PortalStatusIcon extends React.Component<PortalStatusProps & React.HTMLProps<HTMLDivElement>, never> {
    public render(): JSX.Element {
        return (
            <div {...getHTMLProps<HTMLDivElement>(this.props, false)}>
                {cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 && this.props.icon === "share"
                    ? <ShareIcon />
                    : <PortalIcon />
                }
            </div>
        );
    }
}

export { PortalStatusButton, PortalStatusIcon, PortalStatusProps };
